import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { instanceAccessFrom } from '@/lib/instanceAccess';

export function useInstanceAccess() {
  const isSultan = useSelector((s) => s.sultan?.isSultan);
  const instance = useSelector((s) => s.session?.instance);
  return useMemo(() => instanceAccessFrom(isSultan, instance), [isSultan, instance]);
}
